import { render, staticRenderFns } from "./psyTest.vue?vue&type=template&id=1a9a44f2&scoped=true&"
import script from "./psyTest.vue?vue&type=script&lang=js&"
export * from "./psyTest.vue?vue&type=script&lang=js&"
import style0 from "./psyTest.vue?vue&type=style&index=0&id=1a9a44f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9a44f2",
  null
  
)

export default component.exports